import React, {useState} from "react";
import {
    Box,
    Button,
    Checkbox,
    Column,
    Columns,
    Control,
    Field,
    Input,
    TextArea,
    Title,
} from "@allxsmith/bestax-bulma";
import axios from "axios";
import {AsyncTypeahead} from "react-bootstrap-typeahead";


export default function SaleCustomerDetails({finance, onChange, endpoint}){
    const [isLoading, setLoading] = useState(false);
    const [searchData, setSearchData] = useState([]);
    const [, setTypeahead] = useState();


    const handleSearch = query => {
        setLoading(true);
        let url = endpoint + `contacts?contact_type=CC&search=${query}`;
        axios.get(url).then(resp => {
          setSearchData(resp.data.results);
          setLoading(false);
        });
    };

    const handleCustomerSelect = customer => {
        let toUpdate = {
            target: {
                name: "sale_customer",
                value: customer[0]
            }
        }
        onChange(toUpdate);
    }
    const onCheck = e => {
        let toUpdate = {
            target: {
                name: e.target.name,
                value: e.target.checked
            }
        };
        onChange(toUpdate);
    };

    const handleSameCheckBox = e => {
        // Handles setting invoice / delivery address to customer address
        if(e.target.name === "deliver_same_address"){
            if(finance.sale_customer && finance.sale_customer.address_line1){
                onChange({target: {name:"sale_delivery_address", value: (finance.sale_customer.address_line1 +" "+ finance.sale_customer.town)}});
            }
        }
        else if(e.target.name === "invoice_same_address"){
            if(finance.sale_customer && finance.sale_customer.address_line1){
                onChange({target: {name:"sale_invoice_address", value: (finance.sale_customer.address_line1 +" "+ finance.sale_customer.town)}});
            }
        }
    };

    return (
        <Box>
            <Title>Sale Details</Title>
            <Columns isMultiline>
                <Column>
                    <Field>
                        <label className="label">Sale Customer Name</label>
                        <Control>
                            <AsyncTypeahead
                              useCache={false}
                              data-testid="sale-customer-search"
                              id="typeahead"
                              labelKey="display_name"
                              minLength={2}
                              name={"sale_customer"}
                              onSearch={handleSearch}
                              onChange={handleCustomerSelect}
                              placeholder={"Search Customer"}
                              options={searchData}
                              ref={typeahead => setTypeahead(typeahead)}
                              className="typeahead"
                              selected={finance.sale_customer && finance.sale_customer.id ? [finance.sale_customer] : []}
                              isLoading={isLoading}
                            />
                        </Control>
                    </Field>
                </Column>
                <Column>
                    <Field>
                        <label className="label">Sale Customer Address</label>
                        <Control>
                            <Input
                                type={"text"}
                                onChange={onChange}
                                value={finance.sale_customer ? finance.sale_customer.address_line1 + finance.sale_customer.town : ""}
                                name={"sale_customer_address"}
                                disabled={true}
                            />
                        </Control>
                    </Field>
                </Column>
                <Column>
                    <Field>
                        <label className="label">Sale Customer Postcode</label>
                        <Control>
                            <Input
                                type={"text"}
                                onChange={onChange}
                                value={finance.sale_customer ? finance.sale_customer.postcode : ""}
                                name={"sale_customer_postcode"}
                                disabled={true}
                            />
                        </Control>
                    </Field>
                </Column>
                <Column>
                    <Field>
                        <label className="label">Sale Customer Phone Number</label>
                        <Control>
                            <Input
                                type={"text"}
                                onChange={onChange}
                                value={finance.sale_customer ? finance.sale_customer.contact_number : ""}
                                name={"sale_customer_phone"}
                                disabled={true}
                            />
                        </Control>
                    </Field>
                </Column>
                <Column>
                    <Field>
                        <label className="label">Sale Customer Email</label>
                        <Control>
                            <Input
                                onChange={onChange}
                                type={"text"}
                                value={finance.sale_customer ? finance.sale_customer.email : ""}
                                name={"sale_customer_email"}
                                disabled={true}
                            />
                        </Control>
                    </Field>
                </Column>
                <Column>
                    <label className="label">Delivery Address</label>
                    <Field className={"has-addons"}>
                        <Control>
                            <Input
                                onChange={onChange}
                                type={"text"}
                                value={finance.sale_delivery_address}
                                name={"sale_delivery_address"}
                            />
                        </Control>
                        <Control>
                            <Button
                                color={"info"}
                                name={"deliver_same_address"}
                                onClick={handleSameCheckBox}
                            >
                                Customer
                            </Button>
                        </Control>
                    </Field>
                </Column>
                <Column>
                    <label className="label">Sales Invoice Address</label>
                    <Field className={"has-addons"}>
                        <Control>
                            <Input
                                onChange={onChange}
                                type={"text"}
                                value={finance.sale_invoice_address}
                                name={"sale_invoice_address"}
                            />
                        </Control>
                        <Control>
                            <Button
                                color={"info"}
                                name={"invoice_same_address"}
                                onClick={handleSameCheckBox}
                            >
                                Customer
                            </Button>
                        </Control>
                    </Field>
                </Column>
            </Columns>
            <Columns isMultiline>
                <Column>
                    <Field>
                        <label className="label">Sold By</label>
                        <Control>
                            <Input
                                onChange={onChange}
                                type={"text"}
                                value={finance.sold_by}
                                name={"sold_by"}
                            />
                        </Control>
                    </Field>
                </Column>
                <Column>
                    <Field>
                        <label className="label">Balance Method of Payment</label>
                        <Control>
                            <Input
                                onChange={onChange}
                                type={"text"}
                                value={finance.sale_method_of_payment}
                                name={"sale_method_of_payment"}
                            />
                        </Control>
                    </Field>
                </Column>
                <Column>
                    <Field>
                        <label className="label">Warranty Cost</label>
                        <Control className={"has-addons"}>
                            <Input
                                onChange={onChange}
                                type={"number"}
                                value={finance.sale_warranty_cost}
                                name={"sale_warranty_cost"}
                            />
                        </Control>
                    </Field>
                </Column>
                <Column>
                    <Field>
                        <label className="label">Warranty Term</label>
                        <Control>
                            <Input
                                onChange={onChange}
                                type={"text"}
                                value={finance.sale_warranty_term}
                                name={"sale_warranty_term"}
                            />
                        </Control>
                    </Field>
                </Column>
                <Column>
                    <Field>
                        <label className="label">Expected Delivery Date</label>
                        <Control>
                            <Input
                                onChange={onChange}
                                type={"date"}
                                value={finance.sale_expected_delivery_date}
                                name={"sale_expected_delivery_date"}
                            />
                        </Control>
                    </Field>
                </Column>
                <Column>
                    <Field>
                        <label className="label">Trade / Private</label>
                        <Control>
                            <Input
                                onChange={onChange}
                                type={"text"}
                                value={finance.sale_trade_or_private}
                                name={"sale_trade_or_private"}
                            />
                        </Control>
                    </Field>
                </Column>
            </Columns>
            <Columns isMultiline>
                <Column>
                    <Field>
                        <label className="label">Quote / Estimate Made</label>
                        <Control>
                            <Checkbox
                                onChange={onCheck}
                                checked={finance.sale_quote}
                                name={"sale_quote"}
                            />
                        </Control>
                    </Field>
                </Column>
                <Column>
                    <Field>
                        <label className="label">V5</label>
                        <Control>
                            <Checkbox
                                onChange={onCheck}
                                checked={finance.sale_v5}
                                name={"sale_v5"}
                            />
                        </Control>
                    </Field>
                </Column>
                <Column>
                    <Field>
                        <label className="label">MOT</label>
                        <Control>
                            <Checkbox
                                onChange={onCheck}
                                checked={finance.sale_mot}
                                name={"sale_mot"}
                            />
                        </Control>
                    </Field>
                </Column>
                <Column>
                    <Field>
                        <label className="label">Service Book</label>
                        <Control>
                            <Checkbox
                                onChange={onCheck}
                                checked={finance.sale_service_book}
                                name={"sale_service_book"}
                            />
                        </Control>
                    </Field>
                </Column>
                <Column>
                    <Field>
                        <label className="label">Basic Guide</label>
                        <Control>
                            <Checkbox
                                onChange={onCheck}
                                checked={finance.sale_basic_guide}
                                name={"sale_basic_guide"}
                            />
                        </Control>
                    </Field>
                </Column>
                <Column>
                    <Field>
                        <label className="label">Radio Code</label>
                        <Control>
                            <Checkbox
                                onChange={onCheck}
                                checked={finance.sale_radio_code}
                                name={"sale_radio_code"}
                            />
                        </Control>
                    </Field>
                </Column>
                <Column>
                    <Field>
                        <label className="label">Main Key</label>
                        <Control>
                            <Checkbox
                                onChange={onCheck}
                                checked={finance.sale_main_key}
                                name={"sale_main_key"}
                            />
                        </Control>
                    </Field>
                </Column>
                <Column>
                    <Field>
                        <label className="label">Spare Key</label>
                        <Control>
                            <Checkbox
                                onChange={onCheck}
                                checked={finance.sale_spare_key}
                                name={"sale_spare_key"}
                            />
                        </Control>
                    </Field>
                </Column>
                <Column>
                    <Field>
                        <label className="label">Number of Slam Lock Keys</label>
                        <Control>
                            <Input
                                name={"sale_slam_lock_key"}
                                onChange={onChange}
                                value={finance.sale_slam_lock_key}
                                type={"number"}
                            />
                        </Control>
                    </Field>
                </Column>
                <Column>
                    <Field>
                        <label className="label">Final Check</label>
                        <Control>
                            <Checkbox
                                onChange={onCheck}
                                checked={finance.sale_final_check}
                                name={"sale_final_check"}
                            />
                        </Control>
                    </Field>
                </Column>
                <Column>
                    <Field>
                        <label className="label">Settlement</label>
                        <Control>
                            <Checkbox
                                onChange={onCheck}
                                checked={finance.sale_settlement}
                                name={"sale_settlement"}
                            />
                        </Control>
                    </Field>
                </Column>
                <Column>
                    <Field>
                        <label className="label">Clearance</label>
                        <Control>
                            <Checkbox
                                onChange={onCheck}
                                checked={finance.sale_clearance}
                                name={"sale_clearance"}
                            />
                        </Control>
                    </Field>
                </Column>
                <Column>
                    <Field>
                        <label className="label">Paid In Full</label>
                        <Control>
                            <Checkbox
                                onChange={onCheck}
                                checked={finance.sale_paid_in_full}
                                name={"sale_paid_in_full"}
                            />
                        </Control>
                    </Field>
                </Column>
                <Column>
                    <Field>
                        <label className="label">No Vat</label>
                        <Control>
                            <Checkbox
                                onChange={onCheck}
                                checked={finance.no_vat}
                                name={"no_vat"}
                            />
                        </Control>
                    </Field>
                </Column>
            </Columns>
            <Column>
                <label className="label">Print Notes</label>
                <TextArea
                    name={"free_print_text"}
                    onChange={onChange}
                    value={finance.free_print_text}
                />
            </Column>
            <Columns isMultiline>
                <Column>
                    <label className="label">Sold Date</label>
                    <Input
                        onChange={onChange}
                        name={"sold_date"}
                        value={finance.sold_date}
                        type={"date"}
                    />
                </Column>
                <Column/>
                <Column/>
                <Column/>
                <Column/>
            </Columns>
        </Box>
    );




}